import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, Layout, LayoutSplashScreen } from "../_metronic/layout";

import Login from "./pages/login/login";
import Otp from "./pages/login/otp";

import { Backdrop, CircularProgress } from "@mui/material";
import ViewCheckInformation from "./components/checkInfoComponent/viewCheckInformation";
import CartableConfigPage from "./pages/cartable/cartableConfigPage";
import ErrorPage from "./pages/errorPage/errorPage";
import AddCostumerToWhitelist from "./pages/license/AddCostumerToWhitelist";
import WhiteListCostumers from "./pages/license/WhiteListCostumers";
import Welcome from "./pages/loan/welcome";
import NotificationsHistory from "./pages/notificationSupp/notificationsHistory";
import SettlementConfigPage from "./pages/payment/settlementConfigPage";
import SaleConfigPage from "./pages/sale/saleConfigPage";
import { getTokenClaims } from "./services/auth.service";
import ProductConfigPage from "./store/route/productconfigPage";
import SearchConfigPage from "./pages/search/searchConfigPage";
import FinancialConfigPage from "./pages/financial/financialConfigPage";
import NotFound from "./components/notFound/NotFound";
import FacilitiesConfigPage from "./pages/facilities/facilitiesConfigPage";

const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);

export default function BasePage() {
  const canModifyUser = String(getTokenClaims()?.canModifyUser);
  return (
    <>
      <Backdrop
        hidden={true}
        sx={{ color: "#fff", zIndex: () => 10000 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/otp" component={Otp} />
        {
          <Redirect
            exact={true}
            from="/license"
            to="/license/WhiteListHistory"
          />
        }
        {/* <Route path="/dynamicGrid" component={DynamicGrid} /> */}
        <Layout>
          <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
              <ContentRoute
                path="/"
                exact
                component={Welcome}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/sale"
                component={SaleConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/cartable"
                component={CartableConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/financial"
                component={FinancialConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/search"
                component={SearchConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />

              <ContentRoute
                path="/welcome"
                component={Welcome}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/notifications"
                component={NotificationsHistory}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/settlement"
                component={SettlementConfigPage}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/products"
                component={ProductConfigPage}
                children={undefined}
                label={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/facilities"
                component={FacilitiesConfigPage}
                children={undefined}
                label={undefined}
                render={undefined}
              />

              <ContentRoute
                path="/license/AddCostumerToWhitelist"
                component={AddCostumerToWhitelist}
                label={undefined}
                children={undefined}
                render={undefined}
              />
              <ContentRoute
                path="/license/WhiteListHistory"
                component={WhiteListCostumers}
                label={undefined}
                children={undefined}
                render={undefined}
              />

              {/* <ContentRoute
                path="/test12"
                component={Test12}
                label={undefined}
                children={undefined}
                render={undefined}
              />  */}
              <ContentRoute
                path="/*"
                component={NotFound}
                label="خطا"
                children={undefined}
                render={undefined}
              />
              <Route path="/error" component={ErrorPage} />
            </Switch>
          </Suspense>
        </Layout>
      </Switch>
    </>
  );
}
